import { useState, useCallback } from 'react';

export const useBulkSelect = (items = [], idField = 'id') => {
    const [selectedIds, setSelectedIds] = useState(new Set());

    const toggleItem = useCallback((id) => {
        setSelectedIds(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);

    const selectAll = useCallback(() => {
        setSelectedIds(new Set(items.map(item => item[idField])));
    }, [items, idField]);

    const deselectAll = useCallback(() => {
        setSelectedIds(new Set());
    }, []);

    const toggleAll = useCallback(() => {
        if (selectedIds.size === items.length) deselectAll();
        else selectAll();
    }, [selectedIds.size, items.length, selectAll, deselectAll]);

    const isSelected = useCallback((id) => selectedIds.has(id), [selectedIds]);

    const allSelected = items.length > 0 && selectedIds.size === items.length;

    return {
        selectedIds,
        selectedCount: selectedIds.size,
        toggleItem,
        selectAll,
        deselectAll,
        toggleAll,
        isSelected,
        allSelected,
        setSelectedIds,
    };
};
